import Tables from "layouts/tables";
import Notifications from "layouts/notifications";
import SignIn from "layouts/authentication/sign-in";
import SolicitudesPropias from "layouts/tables/SolicitudesPropias";
import HistorialCaso from "layouts/tables/consultaTickets/HisotrialCasos";
import SolicitudesAbastecimiento from "layouts/tables/Abastecimiento/SolicitudesAbastecimiento";
import ComentariosGlpi from "layouts/tables/consultaTickets/ComentariosGlpi";
import ConsultaAbastecimiento from "layouts/tables/Abastecimiento/consultaAbastecimiento";

// MUI icon
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Mis Solicitudes",
    key: "solicitudes-propias",
    icon: <Icon fontSize="small">assignment_ind</Icon>,
    route: "/SolicitudesPropias/:correo",
    component: <SolicitudesPropias />,
  },
  {
    type: "collapse",
    name: "Solicitudes Asignadas",
    key: "solicitudes-asignadas",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/Asignadas",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Casos Abastecimiento",
    key: "casos-abastecimiento",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/Abastecimiento",
    component: <SolicitudesAbastecimiento />,
  },
  {
    type: "collapse",
    name: "Historial Abastecimiento",
    key: "historial-abastecimiento",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/HistorialAbastecimiento",
    component: <ConsultaAbastecimiento />,
  },
  {
    type: "collapse",
    name: "Historial Jurídica",
    key: "historial-casos",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/Historial",
    component: <HistorialCaso />,
  },
  {
    type: "collapse",
    name: "Repositorio GLPI",
    key: "casos-glpi",
    icon: <Icon fontSize="small">comment</Icon>,
    route: "/comentarios",
    component: <ComentariosGlpi />,
  },
  {
    type: "collapse",
    name: "Salir",
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
